// mini-toastr config
export const toastrOptions = {
    timeout: 4000,
};


// WEBPACK FOOTER //
// ./src/thirdparty/options.js